import { Component, OnInit, Input } from '@angular/core';
import { FileInfoType } from '@schoolbelle/api/file';
import { BsModalRef } from "ngx-bootstrap/modal";
import { ModalsComponent } from '../modals.component';

@Component({
  selector: 'modal-media-browser',
  templateUrl: './media-browser-modal.component.html',
  styleUrls: ['./media-browser-modal.component.scss']
})
export class MediaBrowserModalComponent extends ModalsComponent implements OnInit {
  @Input() list:FileInfoType[] = [];
  @Input() index:number = 0; 
  constructor(
    modalRef:BsModalRef,
  ) { 
    super(modalRef);
  }
  ngOnInit() {
  }

}
